export default __webpack_public_path__ + "static/media/expired-bg-sm.9274b110.png";